/**
 * Seletores derivados da rota (§5.1). As regras moram em `model/scene.ts` (DE-11, DE-B02): `effectiveMapMode` é o
 * `.mode` de `effectiveScene` (§9.4.1). A UI os lê só pelos computeds de `state/derived.ts`.
 */
import { effectiveMapMode, effectiveScene, focusUf, isAbroad, viewKey } from '../model/scene';
import type { PlaceRoute, RouteState } from '../model/types';

export { effectiveMapMode, effectiveScene, focusUf, isAbroad, viewKey };

/** Igualdade estrutural de lugares (inclui a zona). */
export function samePlace(a: PlaceRoute, b: PlaceRoute): boolean {
  if (a.kind !== b.kind) return false;
  switch (a.kind) {
    case 'br':
    case 'abroad':
      return true;
    case 'uf':
      return a.uf === (b as typeof a).uf;
    case 'municipality': {
      const m = b as typeof a;
      return a.uf === m.uf && a.ibge === m.ibge && a.zone === m.zone;
    }
    case 'country':
      return a.iso2 === (b as typeof a).iso2;
    case 'abroad_city': {
      const c = b as typeof a;
      return a.iso2 === c.iso2 && a.tse === c.tse;
    }
  }
}

/** Igualdade estrutural de rotas (todos os campos de `RouteState`). */
export function sameRoute(a: RouteState, b: RouteState): boolean {
  return (
    a.office === b.office &&
    a.mapMode === b.mapMode &&
    a.mapCandidate === b.mapCandidate &&
    a.replayTMin === b.replayTMin &&
    a.tvOnEntry === b.tvOnEntry &&
    a.screen === b.screen &&
    samePlace(a.place, b.place)
  );
}
